import { Role } from "lib/build/concepts";

import { useFormatEnum } from "src/common/hooks/useFormatEnum";
import { roleMessages } from "src/messages/generic";

export function useFormatRole(): (key: Role) => string {
	return useFormatEnum(roleMessages);
}
